import React, {ReactNode} from "react"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

import Spacing from "../Spacing"
import {IconTypes} from "../Icon"
import StyledButton from "./styled"

interface Props extends InjectIntl {
  isToggled: boolean,
  onClick: () => void,
  icon?: IconTypes,
  children?: ReactNode
}

const FilterChipToggle: React.FC<Props> = (props) => {
  return (
    <StyledButton isToggled={props.isToggled} onClick={props.onClick} icon={props?.icon}>
      {props.children && <Spacing marginLeft={1}>{props.children}</Spacing>}
    </StyledButton>
  )
}

export default injectIntl(FilterChipToggle)
